import api from '@/api';
import { GetBankAccountSelectionUrlResponse } from '@/types/api/payment-user';
import { useQuery } from '@tanstack/react-query';

export function useBankAccountSelectionUrlQuery(redirectUrl: string) {
  return useQuery<GetBankAccountSelectionUrlResponse>({
    queryKey: ['payment-users', 'bank-account-selection-url', redirectUrl],
    queryFn: () => api.paymentUser.getBankAccountSelectionUrl(redirectUrl),
    enabled: Boolean(redirectUrl),
  });
}
